<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";


import {


} from 'devextreme-vue/data-grid';


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,



  },
  data() {

    return {
      title: "Dashboard Fretes",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Dashboard Fretes",
          active: true
        }
      ],
    };
  },
  created() {

  },
  mounted() {

  },



  methods: {


  },

};

</script>
<template>
  <Layout>


    <div class="row" >


          <!--            <h4 class="card-title">Endereçamentos de estoque</h4>-->
          <!--            <p class="card-title-desc">Produtos novos ou perto de seu vencimento</p>-->

          <!-- 16:9 aspect ratio -->
          <div class="ratio ratio-16x9" style="min-height: 1700px;">
            <iframe class="embed-responsive-item" src="https://dashmapas01-1362732cd3ba.herokuapp.com/"></iframe>
          </div>


    </div>





  </Layout>
</template>
